import { useEffect, useState } from "react";
import DateMonthYearSelector from "./DateMonthYearSelector";
import CustomDropzone from "components/Dropzone";
import CustomizeDatePicker from "components/DatePicker";
import OptionCarBrands from "./OptionCarBrands";
import OptionProvince from "components/OptionProvince";
import { useCarStatuses } from "contexts/CarStatusContext";
const {
  Box,
  Typography,
  Divider,
  Card,
  CardHeader,
  Grid,
  TextField,
  Select,
  Autocomplete,
  RadioGroup,
  Radio,
  FormControlLabel,
} = require("@mui/material");

const RenderFieldsCars = ({
  sx,
  formik,
  setCarImage,
  images = [],
  setDeleteImage,
  type = "buy",
  isEdit = false,
  data = {},
}) => {
  const [images_files, setImagesFiles] = useState([]);
  const [initialUrls, setInitialUrls] = useState([]);
  const [deleteImg, setDeleteImg] = useState([]);
  const [error, setError] = useState(null);
  const { carStatuses } = useCarStatuses();

  useEffect(() => {
    if (Array.isArray(images) && images.length > 0) {
      const files = images
        .filter((img) => img && img.url)
        .map((image) => ({
          picture: image.url,
          id: image.id,
          status: "complete",
        }));
      setInitialUrls(files);
    }
  }, [images]);

  const handleDeleteFile = (index, id) => {
    setImagesFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      formik.setFieldValue("carImage", newFiles);
      if (newFiles.length === 0) {
        setError(null);
      }
      return newFiles;
    });

    if (id) {
      setDeleteImg((prevDeleteImg) => {
        const updatedImg = [...prevDeleteImg, id];
        return updatedImg;
      });
    }
  };

  useEffect(() => {
    if (deleteImg.length > 0 && setDeleteImage) {
      setDeleteImage(deleteImg);
    }
  }, [deleteImg, setDeleteImage]);

  const handleFilesChange = (files) => {
    setImagesFiles(files);
    formik.setFieldValue("carImage", files);
    if (files.length === 0) {
      setError("กรุณาอัพโหลดรูปภาพอย่างน้อย 1 รูป");
    } else {
      setError(null);
    }
  };

  useEffect(() => {
    if (images_files.length > 0) {
      console.log("images_files", images_files);
      const updatedFiles = images_files.map((file) => file.file || file);
      setCarImage(updatedFiles);
    } else {
      setCarImage([]);
    }
  }, [images_files]);

  return (
    <Box sx={{ ...sx }}>
      <Typography
        variant="h5"
        sx={{
          mb: 1,
        }}
      >
        ข้อมูลรถ
      </Typography>
      <Box
        sx={{
          borderRadius: 2,
          border: "1px solid #E0E0E0",
        }}
      >
        {isEdit ? (
          <Typography
            sx={{
              whiteSpace: "nowrap",
              padding: 2,
              fontSize: "20px",
              color: "rgba(0, 0, 0, 0.6)",
              fontWeight: 300,
              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
            }}
          >
            {data ? data.car_name : "รถ"}
          </Typography>
        ) : (
          <Typography
            variant="h6"
            sx={{
              whiteSpace: "nowrap",
              padding: 2,
            }}
          >
            รถ
          </Typography>
        )}
        <Divider
          sx={{
            background: "linear-gradient(90deg, #00BB9F, #B0EE93)",
            height: "4px",
            boxShadow: "none",
            border: "none",
          }}
        />
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ชื่อรถ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกชื่อรถ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  onChange={(e) => {
                    formik.setFieldValue("car_name", e.target.value);
                  }}
                  value={formik.values.car_name || ""}
                  error={
                    formik.touched.car_name && Boolean(formik.errors.car_name)
                  }
                  helperText={
                    formik.touched.car_name && formik.errors.car_name
                      ? formik.errors.car_name
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ประเภทรถ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  fullWidth
                  options={["รถยนต์", "มอเตอร์ไซต์"]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="เลือกประเภทรถ"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          bgcolor: "white",
                          height: "40px",
                        },
                      }}
                      error={
                        formik.touched.car_type &&
                        Boolean(formik.errors.car_type)
                      }
                      helperText={
                        formik.touched.car_type && formik.errors.car_type
                          ? formik.errors.car_type
                          : ""
                      }
                    />
                  )}
                  value={formik.values.car_type || ""}
                  onChange={(event, value) =>
                    formik.setFieldValue("car_type", value)
                  }
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ทะเบียนรถ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกทะเบียนรถ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  onChange={(e) => {
                    formik.setFieldValue("license_plate", e.target.value);
                  }}
                  value={formik.values.license_plate || ""}
                  error={
                    formik.touched.license_plate &&
                    Boolean(formik.errors.license_plate)
                  }
                  helperText={
                    formik.touched.license_plate && formik.errors.license_plate
                      ? formik.errors.license_plate
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  จังหวัด<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={4}>
                <OptionProvince
                  value={formik.values.license_province || null}
                  onChangeValue={(value) => {
                    formik.setFieldValue("license_province", value);
                  }}
                  error={
                    formik.touched.license_province &&
                    Boolean(formik.errors.license_province)
                  }
                  helperText={
                    formik.touched.license_province &&
                    formik.errors.license_province
                      ? formik.errors.license_province
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  เลขตัวรถ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกเลขตัวรถ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.car_no || ""}
                  onChange={(e) => {
                    formik.setFieldValue("car_no", e.target.value);
                  }}
                  error={formik.touched.car_no && Boolean(formik.errors.car_no)}
                  helperText={
                    formik.touched.car_no && formik.errors.car_no
                      ? formik.errors.car_no
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  วันที่จดทะเบียน<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                {/* <DateMonthYearSelector
                  key={"license_date"}
                  onDateChange={(e) => {
                    console.log("Selected license date:", e);
                    formik.setFieldValue("license_date", e);
                  }}
                /> */}
                <CustomizeDatePicker
                  key={"license_date_picker"}
                  value={formik.values.license_date || null}
                  onChange={(e) => {
                    formik.setFieldValue("license_date", e);
                  }}
                  error={
                    formik.touched.license_date &&
                    Boolean(formik.errors.license_date)
                  }
                  helperText={
                    formik.touched.license_date && formik.errors.license_date
                      ? formik.errors.license_date
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  วันหมดอายุภาษี<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                {/* <DateMonthYearSelector
                  key={"tax_expire_date"}
                  onDateChange={(e) =>
                    formik.setFieldValue("tax_expire_date", e)
                  }
                /> */}
                <CustomizeDatePicker
                  key={"tax_expire_date_picker"}
                  value={formik.values.tax_expire_date || null}
                  onChange={(e) => {
                    formik.setFieldValue("tax_expire_date", e);
                  }}
                  error={
                    formik.touched.tax_expire_date &&
                    Boolean(formik.errors.tax_expire_date)
                  }
                  helperText={
                    formik.touched.tax_expire_date &&
                    formik.errors.tax_expire_date
                      ? formik.errors.tax_expire_date
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  วันหมดอายุพ.ร.บ.<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                {/* <DateMonthYearSelector
                  key={"compulsory_expire_date"}
                  onDateChange={(e) =>
                    formik.setFieldValue("compulsory_expire_date", e)
                  }
                /> */}
                <CustomizeDatePicker
                  key={"compulsory_expire_date_picker"}
                  value={formik.values.compulsory_expire_date || null}
                  onChange={(e) => {
                    formik.setFieldValue("compulsory_expire_date", e);
                  }}
                  error={
                    formik.touched.compulsory_expire_date &&
                    Boolean(formik.errors.compulsory_expire_date)
                  }
                  helperText={
                    formik.touched.compulsory_expire_date &&
                    formik.errors.compulsory_expire_date
                      ? formik.errors.compulsory_expire_date
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ลักษณะ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกลักษณะ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.characteristic || ""}
                  onChange={(e) => {
                    formik.setFieldValue("characteristic", e.target.value);
                  }}
                  error={
                    formik.touched.characteristic &&
                    Boolean(formik.errors.characteristic)
                  }
                  helperText={
                    formik.touched.characteristic &&
                    formik.errors.characteristic
                      ? formik.errors.characteristic
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ยี่ห้อ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={5}>
                <OptionCarBrands
                  value={formik.values.car_brand_id || null}
                  onChangeValue={(value) => {
                    formik.setFieldValue("car_brand_id", value);
                  }}
                  error={
                    formik.touched.car_brand_id &&
                    Boolean(formik.errors.car_brand_id)
                  }
                  helperText={
                    formik.touched.car_brand_id && formik.errors.car_brand_id
                      ? formik.errors.car_brand_id
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  สี<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกสี"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.color || ""}
                  onChange={(e) => {
                    formik.setFieldValue("color", e.target.value);
                  }}
                  error={formik.touched.color && Boolean(formik.errors.color)}
                  helperText={
                    formik.touched.color && formik.errors.color
                      ? formik.errors.color
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  รุ่น<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกรุ่น"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.model || ""}
                  onChange={(e) => {
                    formik.setFieldValue("model", e.target.value);
                  }}
                  error={formik.touched.model && Boolean(formik.errors.model)}
                  helperText={
                    formik.touched.model && formik.errors.model
                      ? formik.errors.model
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ชนิดเชื้อเพลิง<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  fullWidth
                  options={["เบนซิน", "ดีเซล", "ไฟฟ้า"]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="เลือกชนิดเชื้อเพลิง"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          bgcolor: "white",
                          height: "40px",
                        },
                      }}
                      error={
                        formik.touched.fuel_type &&
                        Boolean(formik.errors.fuel_type)
                      }
                      helperText={
                        formik.touched.fuel_type && formik.errors.fuel_type
                          ? formik.errors.fuel_type
                          : ""
                      }
                    />
                  )}
                  value={formik.values.fuel_type || ""}
                  onChange={(event, value) =>
                    formik.setFieldValue("fuel_type", value)
                  }
                  sx={{ width: "100%", mt: 1 }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ยื่ห้อเครื่องยนต์<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกยี่ห้อเครื่องยนต์"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.engine_brand || ""}
                  onChange={(e) => {
                    formik.setFieldValue("engine_brand", e.target.value);
                  }}
                  error={
                    formik.touched.engine_brand &&
                    Boolean(formik.errors.engine_brand)
                  }
                  helperText={
                    formik.touched.engine_brand && formik.errors.engine_brand
                      ? formik.errors.engine_brand
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  เลขเครื่องยนต์<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกเลขเครื่องยนต์"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.engine_number || ""}
                  onChange={(e) => {
                    formik.setFieldValue("engine_number", e.target.value);
                  }}
                  error={
                    formik.touched.engine_number &&
                    Boolean(formik.errors.engine_number)
                  }
                  helperText={
                    formik.touched.engine_number && formik.errors.engine_number
                      ? formik.errors.engine_number
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  เลขถังแก๊ส
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกเลขถังแก๊ส (ถ้ามี)"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.gas_number || ""}
                  onChange={(e) => {
                    formik.setFieldValue("gas_number", e.target.value);
                  }}
                  error={
                    formik.touched.gas_number &&
                    Boolean(formik.errors.gas_number)
                  }
                  helperText={
                    formik.touched.gas_number && formik.errors.gas_number
                      ? formik.errors.gas_number
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  จำนวนสูบ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={2.5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  placeholder="กรุณากรอกจำนวนสูบ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.number_of_engine_cylinders || ""}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "number_of_engine_cylinders",
                      e.target.value
                    );
                  }}
                  error={
                    formik.touched.number_of_engine_cylinders &&
                    Boolean(formik.errors.number_of_engine_cylinders)
                  }
                  helperText={
                    formik.touched.number_of_engine_cylinders &&
                    formik.errors.number_of_engine_cylinders
                      ? formik.errors.number_of_engine_cylinders
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  ซีซี<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={2.5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  placeholder="กรุณากรอกซีซี"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.cc || ""}
                  onChange={(e) => {
                    formik.setFieldValue("cc", e.target.value);
                  }}
                  error={formik.touched.cc && Boolean(formik.errors.cc)}
                  helperText={
                    formik.touched.cc && formik.errors.cc
                      ? formik.errors.cc
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1.5}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  แรงม้า<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={2.5}>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  placeholder="กรุณากรอกแรงม้า"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.horsepower || ""}
                  onChange={(e) => {
                    formik.setFieldValue("horsepower", e.target.value);
                  }}
                  error={
                    formik.touched.horsepower &&
                    Boolean(formik.errors.horsepower)
                  }
                  helperText={
                    formik.touched.horsepower && formik.errors.horsepower
                      ? formik.errors.horsepower
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  น้ำหนักรถ (กก.)<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={2.5}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  placeholder="กรุณากรอกน้ำหนักรถ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.weight || ""}
                  onChange={(e) => {
                    formik.setFieldValue("weight", e.target.value);
                  }}
                  error={formik.touched.weight && Boolean(formik.errors.weight)}
                  helperText={
                    formik.touched.weight && formik.errors.weight
                      ? formik.errors.weight
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  ที่นั่ง<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={2.5}>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  placeholder="กรุณากรอกที่นั่ง"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.seat || ""}
                  onChange={(e) => {
                    formik.setFieldValue("seat", e.target.value);
                  }}
                  error={formik.touched.seat && Boolean(formik.errors.seat)}
                  helperText={
                    formik.touched.seat && formik.errors.seat
                      ? formik.errors.seat
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1.5}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  เลขไมล์รถ<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={2.5}>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  placeholder="กรุณากรอกเลขไมล์รถ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.car_mileage || null}
                  onChange={(e) => {
                    formik.setFieldValue("car_mileage", e.target.value);
                  }}
                  error={
                    formik.touched.car_mileage &&
                    Boolean(formik.errors.car_mileage)
                  }
                  helperText={
                    formik.touched.car_mileage && formik.errors.car_mileage
                      ? formik.errors.car_mileage
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ราคา<span style={{ color: "red" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  placeholder="กรุณากรอกราคา"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.car_price || null}
                  onChange={(e) => {
                    formik.setFieldValue("car_price", e.target.value);
                  }}
                  error={
                    formik.touched.car_price && Boolean(formik.errors.car_price)
                  }
                  helperText={
                    formik.touched.car_price && formik.errors.car_price
                      ? formik.errors.car_price
                      : ""
                  }
                  inputProps={{ min: 0 }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
                  ประกันรถ
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="ถ้ามีประกัน กรุณากรอกประกันรถ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.insurance_company || ""}
                  onChange={(e) => {
                    formik.setFieldValue("insurance_company", e.target.value);
                  }}
                  error={
                    formik.touched.insurance_company &&
                    Boolean(formik.errors.insurance_company)
                  }
                  helperText={
                    formik.touched.insurance_company &&
                    formik.errors.insurance_company
                      ? formik.errors.insurance_company
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    textAlign: {
                      xs: "left",
                      sm: "left",
                      md: "right",
                    },
                  }}
                >
                  ชั้น
                </Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={4}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกชั้นประกัน"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.insurance_level || ""}
                  onChange={(e) => {
                    formik.setFieldValue("insurance_level", e.target.value);
                  }}
                  error={
                    formik.touched.insurance_level &&
                    Boolean(formik.errors.insurance_level)
                  }
                  helperText={
                    formik.touched.insurance_level &&
                    formik.errors.insurance_level
                      ? formik.errors.insurance_level
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1">วันหมดอายุประกันรถ</Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                {/* <DateMonthYearSelector
                  key={"insurance_expire_date"}
                  onDateChange={(e) =>
                    formik.setFieldValue("insurance_expire_date", e)
                  }
                /> */}
                <CustomizeDatePicker
                  key={"insurance_expire_date_picker"}
                  value={formik.values.insurance_expire_date || null}
                  onChange={(e) => {
                    formik.setFieldValue("insurance_expire_date", e);
                  }}
                  error={
                    formik.touched.insurance_expire_date &&
                    Boolean(formik.errors.insurance_expire_date)
                  }
                  helperText={
                    formik.touched.insurance_expire_date &&
                    formik.errors.insurance_expire_date
                      ? formik.errors.insurance_expire_date
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          {type === "buy" && (
            <Grid item xs={12} sm={12} md={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={2} sm={2} md={2}>
                  <Typography variant="body1">รูปแบบการซื้อรถ</Typography>
                </Grid>
                <Grid item xs={10} sm={10} md={10}>
                  <RadioGroup
                    row
                    name="carPurchaseType"
                    defaultValue="cash"
                    sx={{ display: "flex", gap: 2 }}
                    onChange={(e) => {
                      formik.setFieldValue("purchase_type", e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="cash"
                      control={<Radio />}
                      label="เงินสด"
                    />
                    <FormControlLabel
                      value="installment"
                      control={<Radio />}
                      label="เงินผ่อน"
                    />
                  </RadioGroup>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1">รอยตำหนิ</Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกรอยตำหนิ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.defect || ""}
                  onChange={(e) => {
                    formik.setFieldValue("defect", e.target.value);
                  }}
                  error={formik.touched.defect && Boolean(formik.errors.defect)}
                  helperText={
                    formik.touched.defect && formik.errors.defect
                      ? formik.errors.defect
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1">สถานะรถ</Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                <Autocomplete
                  fullWidth
                  options={
                    carStatuses.filter((status) =>
                      [2, 3].includes(status.id)
                    ) || []
                  }
                  getOptionLabel={(option) => (option.name ? option.name : "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="เลือกสถานะรถ"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          bgcolor: "white",
                          height: "40px",
                        },
                      }}
                    />
                  )}
                  value={
                    carStatuses
                      ? carStatuses.find(
                          (option) => option.id === formik.values.car_status_id
                        ) || 1
                      : 1
                  }
                  onChange={(event, value) =>
                    formik.setFieldValue(
                      "car_status_id",
                      value ? value.id : null
                    )
                  }
                  error={
                    formik.touched.car_status_id &&
                    Boolean(formik.errors.car_status_id)
                  }
                  helperText={
                    formik.touched.car_status_id && formik.errors.car_status_id
                      ? formik.errors.car_status_id
                      : ""
                  }
                  sx={{ width: "100%" }}
                  disableClearable
                  disabled={
                    (type === "buy" && !isEdit) ||
                    (type === "consignment" && !isEdit) ||
                    data?.car_status_id === 4 ||
                    data?.car_status_id === 1
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2} sm={2} md={2}>
                <Typography variant="body1">หมายเหตุ</Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="กรุณากรอกหมายเหตุ"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={formik.values.note || ""}
                  onChange={(e) => {
                    formik.setFieldValue("note", e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Typography variant="body1">รูปรถ</Typography>
            <Typography variant="body1">{images_files.length}/5</Typography>
          </Box>

          <CustomDropzone
            maxImages={5}
            files={images_files}
            initialUrls={initialUrls}
            setFiles={setImagesFiles}
            setError={setError}
            onDelete={handleDeleteFile}
            onFilesChange={handleFilesChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default RenderFieldsCars;
